const login = {
  title: 'Pozdravljeni!',
  subtitle: 'Vnesite svoj e-poštni naslov.',
  subtitleCode: 'Vnesite kodo, poslano na vaš e-poštni naslov.',

  email: 'Email',
  emailDescription: 'Prejeli boste email z enkratnim geslom za prijavo.',
  code: 'Koda',
  codeDescription: 'Preverite svoj e-poštni naslov za 8-mestno kodo.',

  continue: 'Nadaljuj',
  verify: 'Preveri kodo',
  cancel: 'Prekliči',
  resend: 'Pošlji ponovno',

  otpTitle: 'Enkratno geslo',
  otpSubtitle: 'Vnesite kodo, poslano na vaš e-poštni naslov.',
  otpContinue: 'Nadaljuj',
  sending: 'Pošiljanje...',
  verifying: 'Preverjanje...',
  back: 'Nazaj',
  password: 'Geslo',

  socialLogin: {
    apple: 'Nadaljuj z Apple',
    google: 'Nadaljuj z Google',
  },

  verifyingSignIn: 'Preverjanje prijave...',
  signInFailed: 'Prijava ni uspela. Poskusite znova.',

  downloadBanner: {
    title: 'Prenesite aplikacijo',
    subtitle: 'Uporabite Voicefill Medical v naravni aplikaciji.',
    cta: 'Prenesi',
    dismissA11y: 'Zapri vrstico',
  },
};

export default login;
